import { createFileRoute } from '@tanstack/react-router';
import { Sparkles } from 'lucide-react';
import { EmptyState, PageHeader } from '~/components/data';
import shared from './_auth._shared.module.css';

export const Route = createFileRoute('/_auth/chat')({ component: ChatPage });

/**
 * FE-106: empty state теперь следует AI/NLQ pattern. ✦ Sparkles icon
 * `--agent` color, italic placeholder с примером запроса, keyboard hint «/».
 */
function ChatPage(): JSX.Element {
  return (
    <div className={shared.page}>
      <PageHeader title="Чат" description="Диалоговая аналитика агента" />
      <EmptyState
        // FE-106: Sparkles (✦) для AI-feel — заменил MessageSquare.
        icon={<Sparkles size={32} color="var(--color-agent, var(--color-info))" />}
        title="Спросите агента — он ответит цифрами с провенансом"
        description={
          <span style={{ fontStyle: 'italic' }}>
            Например: «остатки на складе А за май», «расхождения с 1С за квартал», «себестоимость
            производственного заказа WO-2026-00007». Откройте панель — кнопка справа внизу или
            клавиша «/».
          </span>
        }
      />
    </div>
  );
}
